import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import CopyIcon from "../components/ReferralLPV2/assets/copy.svg";
import TextField from "@mui/material/TextField";
import styles from "./ReferralLPV2/styles.module.scss";
import { posthog } from "posthog-js";
function PurlShare({ link }) {
    return (_jsx(_Fragment, { children: _jsx(TextField, { value: link, InputProps: {
                readOnly: true,
                className: styles.textField,
                id: "referralLink",
                endAdornment: (_jsx("button", { onClick: () => {
                        // eslint-disable-next-line
                        navigator.clipboard.writeText(link);
                        const inputEl = document.getElementById("referralLink");
                        if (!inputEl)
                            return;
                        inputEl.value = "Copied!";
                        setTimeout(() => {
                            inputEl.value = link;
                        }, 1000);
                        posthog.capture("copied_referral_link", { logged_in: true });
                    }, style: {
                        background: "none",
                        border: "none",
                        cursor: "pointer",
                    }, children: _jsx("img", { alt: "Copy Icon", src: CopyIcon }) })),
                style: {
                    width: "100%",
                    textTransform: "uppercase",
                },
            }, style: {
                width: "100%",
                display: "block",
                margin: "0 auto",
            } }) }));
}
export default PurlShare;
